import React from "react";

const About = () => {
  return (
    <div className="text-center">
      <h1 style={{ color: "green" }}>Club Members</h1>
      <hr />
      <h3>Advisors</h3>
      <div className="container mt-3" style={{ width: "1400px" }}>
        <div className="card-group">
          <div className="card m-2" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/sandip.jpg"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Founder-President</h6>
              <p className="card-text">Sandip Dangol</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/bijesh.jpg"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Former-president</h6>
              <p className="card-text">Bijesh Shrestha</p>
            </div>
          </div>

          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="assest/saroj.jpg"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Former-president</h6>
              <p className="card-text">Saroj Maharjan</p>
            </div>
          </div>
          <div className="card m-2 border-0" style={{ width: "200px" }}>
          </div>
          <div className="card m-2 border-0" style={{ width: "200px" }}>
          </div>
          </div>
          </div>
      <hr />
      <h3>Committee Member</h3>
      <div className="container mt-3" style={{ width: "1400px" }}>
        <div className="card-group">
          <div className="card m-2" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/sudarshan.jpg"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">President</h6>
              <p className="card-text">Sudarshan shrestha</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Vice-president</h6>
              <p className="card-text">Sanam Dangol</p>
            </div>
          </div>

          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Treasurer</h6>
              <p className="card-text">Heronika</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/rajiv.jpg"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Secretary General</h6>
              <p className="card-text">Rajiv Dangol</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Secretary</h6>
              <p className="card-text">Bijay Dangol</p>
            </div>
          </div>

          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="assest/raman.jpg"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Board-member</h6>
              <p className="card-text">Raman Dangol</p>
            </div>
          </div>
        </div>
        <div className="card-group">
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/shan.jpg"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Board-member</h6>
              <p className="card-text">shan Dangol</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/ranjit.jpg"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Board-Member</h6>
              <p className="card-text">Ranjit Dangol</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Board-Member</h6>
              <p className="card-text">Aashish Shrestha</p>
            </div>
          </div>

          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Board-Member</h6>
              <p className="card-text">Rajkumar Dangol</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Board-Member</h6>
              <p className="card-text">Sostika Dangol</p>
            </div>
          </div>
          <div className="card m-2 border-0" style={{ width: "200px" }}>
          </div>
        </div>
      </div>
      <hr />
      <h3>Member</h3>
      <div className="container mt-3" style={{ width: "1400px" }}>
        <div className="card-group">
          <div className="card m-2" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Aakriti Shrestha</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Aman Maharjan</p>
            </div>
          </div>

          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Jamuna Karmacharya</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Kabeen Dangol</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Keran Shrestha</p>
            </div>
          </div>

          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Manoj Shrestha</p>
            </div>
          </div>
        </div>
        <div className="card-group">
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/Sandipa.jpg"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Sandipa Dangol</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/Pramila.jpg"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Pramila Dangol</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Promod Dangol</p>
            </div>
          </div>

          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="assest/reejan.jpg"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Reejan Dangol</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Rohit Maharjan</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Roshan Dangol</p>
            </div>
          </div>
        </div>
        <div className="card-group">
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/Rubina.jpg"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Rubina Dangol</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Samrat Shrestha</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Sapana Dangol</p>
            </div>
          </div>

          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Sapoot Dangol</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Sayesh Dangol</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Suman Dangol</p>
            </div>
          </div>
        </div>
        <div className="card-group">
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">suresh Dangol</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Sushant Shrestha</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Riki Dangol</p>
            </div>
          </div>

          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Roshan Dangol</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
            <img
              className="card-img-bottom"
              src="./assest/user.png"
              alt="Card image"
              style={{ width: "100%" }}
            />
            <div className="card-body">
              <h6 className="card-title">Member</h6>
              <p className="card-text">Sazan  Shrestha</p>
            </div>
          </div>
          <div className="card m-2 border" style={{ width: "200px" }}>
          </div>
        </div>
      </div>
      <br/>
    </div>
  );
};

export default About;
